export const abc = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];